module.exports = __webpack_public_path__ + "static/img/my-background.aaff186.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/my-background.png
// module id = Y05U
// module chunks = 0